module.exports = __webpack_public_path__ + "img/emoji_162.5f6c6163.png";